import axios from 'axios';
import { AUTH_TOKEN_NAME } from '../controllers/AutenticacaoController';

const api = createApi();

function createApi() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL || "https://promatec-api.danysoft.net",
    // [AJUSTE 12/08/2026] O default do axios e 0 = ESPERAR PARA SEMPRE. Se a resposta
    // nunca chega, a tela fica em loading sem fim e sem mensagem. Isto e uma rede de
    // seguranca, nao o prazo esperado: o nginx corta em 60s e a API em 30s, entao
    // qualquer coisa que passe de 90s e conexao pendurada de verdade.
    timeout: 90000,
  })
  const token = localStorage.getItem(AUTH_TOKEN_NAME)

  if (token) {
    api.defaults.headers.Authorization = `Bearer ${token}`
  }

  api.interceptors.request.use(
    (config) => {
      config.headers['Accept'] = '*/*';
      config.headers['Content-Type'] = 'application/json';
      return config;
    },
    (error) => {
      // [AJUSTE 12/08/2026] Faltava o reject. Sem ele o erro era ENGOLIDO e a cadeia
      // resolvia com undefined, ou seja: quem chamou recebia "sucesso" com resposta
      // vazia em vez de cair no catch. Erro de request e raro, mas quando acontecia
      // ficava invisivel.
      console.log(error.message);
      return Promise.reject(error);
    }
  );
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem(AUTH_TOKEN_NAME);

        window.location.href = "/";
      }
      return Promise.reject(error);
    }
  );

  return api;
}

export default api;
